__turbopack_context__.v({
  "even": "MerchClothingSizingModal-module__l_c_sa__even",
  "header": "MerchClothingSizingModal-module__l_c_sa__header",
  "odd": "MerchClothingSizingModal-module__l_c_sa__odd",
  "root": "MerchClothingSizingModal-module__l_c_sa__root",
  "sizeCell": "MerchClothingSizingModal-module__l_c_sa__sizeCell",
  "sizingTable": "MerchClothingSizingModal-module__l_c_sa__sizingTable",
  "subtitle": "MerchClothingSizingModal-module__l_c_sa__subtitle",
  "tableContainer": "MerchClothingSizingModal-module__l_c_sa__tableContainer",
  "title": "MerchClothingSizingModal-module__l_c_sa__title",
});
